import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { OrderFileDto, OrderVersionDto } from '../../../interfaces/OrderDetail';
import { QuoteVersionDetail } from './QuoteVersionDetail';

const { TabPane } = Tabs;

interface QuoteVersionTabsProps {
  versions: OrderVersionDto[];
  onActiveVersionChange: (version: OrderVersionDto) => void;
  allowUpdates?: boolean;
  onSaved?: () => void;
  onRequestComment?: (text: string) => void;
}

export const QuoteVersionTabs: React.FC<QuoteVersionTabsProps> = ({ versions, onActiveVersionChange, allowUpdates, onSaved, onRequestComment }) => {
  const [activeKey, setActiveKey] = useState(versions[0]?.versionLabel);

  useEffect(() => {
    setActiveKey(versions[0]?.versionLabel);
  }, [versions]);

  const handleChange = (key: string) => {
    setActiveKey(key);
    const v = versions.find((v) => v.versionLabel === key);
    if (v) onActiveVersionChange(v);
  };

  return (
    <Tabs activeKey={activeKey} onChange={handleChange}>
      {versions.map((v) => (
        <TabPane tab={`Version ${v.versionLabel}`} key={v.versionLabel}>
          <QuoteVersionDetail version={v} allowUpdates={allowUpdates} onSaved={onSaved} onRequestComment={onRequestComment} />
        </TabPane>
      ))}
    </Tabs>
  );
};
